var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { injectable } from 'inversify';
const ROTATION_ANGLE = -90;
const IMAGE_QUALITY = 1;
let ImageRotator = class ImageRotator {
    /**
     * Вращать изображение на 90° против часовой стрелки
     * При этом изображение отрисовыается на canvas,
     * чей 2-мерный контекстный метод rotate принимает значение в радианах (1 радиан = градусы * Пи/180).
     * Вращаем контекст и затем рисуем изображение
     *
     * @param blob - Изображение в виде Blob
     * @returns Повёрнутое изображение в виде Blob или null при ошибке
     */
    rotate(blob) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                const img = new Image();
                img.setAttribute('crossorigin', 'anonymous');
                img.src = URL.createObjectURL(blob);
                img.onload = function () {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    if (!ctx)
                        return;
                    ctx.canvas.width = img.height;
                    ctx.canvas.height = img.width;
                    ctx.translate(canvas.width / 2, canvas.height / 2); //eslint-disable-line no-magic-numbers
                    ctx.rotate((ROTATION_ANGLE * Math.PI) / 180); //eslint-disable-line no-magic-numbers
                    ctx.translate(-canvas.height / 2, -canvas.width / 2); //eslint-disable-line no-magic-numbers
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    canvas.toBlob((updatedBlob) => {
                        resolve(updatedBlob);
                    }, blob.type, IMAGE_QUALITY);
                };
            });
        });
    }
};
ImageRotator = __decorate([
    injectable()
], ImageRotator);
export { ImageRotator };
